import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneAlt, faEnvelope, faLocationDot, faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faInstagram, faWhatsapp, faTiktok, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import './Footer.css';

const PHONE = process.env.REACT_APP_MOBILE_NUMBER1;
const EMAIL = process.env.REACT_APP_EMAIL;
const STEM_VERIFY_URL = 'https://blockchain.stem.org/fa3514bb-439a-4ce8-a44e-56a2ed4947db#acc.Z4myOMLG';

const SOCIALS = [
  { label: 'Instagram', href: 'https://instagram.com/robomind.lb', icon: faInstagram },
  { label: 'Facebook', href: 'https://facebook.com/robomind.lb', icon: faFacebookF },
  { label: 'WhatsApp', href: `https://wa.me/${PHONE}`, icon: faWhatsapp },
  { label: 'TikTok', href: 'https://tiktok.com/@robomind.lb', icon: faTiktok },
  { label: 'LinkedIn', href: 'https://linkedin.com/company/robomind-lb', icon: faLinkedinIn },
];

const LINK_GROUPS = [
  {
    title: 'Learn',
    links: [
      { label: 'Our Programs', to: '/Programs' },
      { label: 'Pricing Plans', to: '/PricingPlans' },
      { label: 'Curriculum', to: '/Curriculum' },
      { label: 'Robotics Activities', to: '/Wedo20' },
      { label: 'Events', to: '/Events' },
    ],
  },
  {
    title: 'RoboMind',
    links: [
      { label: 'About Us', to: '/AboutUs' },
      { label: 'Student Achievements', to: '/StudentAchievements' },
      { label: 'Book a Free Trial', to: '/FreeTrial' },
      { label: 'Join Free Class', to: '/joinfreeclass' },
      { label: 'Login', to: '/Login' },
    ],
  },
];

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="rmf">
      <div className="rmf-inner">
        <div className="rmf-grid">
          {/* Brand + contact */}
          <div className="rmf-brand">
            <Link to="/" className="rmf-logo" aria-label="RoboMind home">
              <img src="/assets/img/logo/logowhitenew.png" alt="RoboMind Coding Education" />
            </Link>
            <p className="rmf-about">
              Helping kids become creators of technology. Online live 1-to-1 coding, AI and robotics classes for ages
              6–17.
            </p>

            <ul className="rmf-contact">
              {PHONE && (
                <li>
                  <FontAwesomeIcon icon={faPhoneAlt} />
                  <a href={`tel:${PHONE}`}>{PHONE}</a>
                </li>
              )}
              {EMAIL && (
                <li>
                  <FontAwesomeIcon icon={faEnvelope} />
                  <a href={`mailto:${EMAIL}`}>{EMAIL}</a>
                </li>
              )}
              <li>
                <FontAwesomeIcon icon={faLocationDot} />
                <span>Lebanon · Online worldwide</span>
              </li>
            </ul>
          </div>

          {/* Link groups */}
          {LINK_GROUPS.map((group) => (
            <nav key={group.title} className="rmf-col" aria-label={group.title}>
              <h3 className="rmf-title">{group.title}</h3>
              <ul className="rmf-links">
                {group.links.map((l) => (
                  <li key={l.to}>
                    <Link to={l.to}>{l.label}</Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}

          {/* Social + accreditation */}
          <div className="rmf-col">
            <h3 className="rmf-title">Follow us</h3>
            <div className="rmf-social">
              {SOCIALS.map((s) => (
                <a key={s.label} href={s.href} target="_blank" rel="noopener noreferrer" aria-label={s.label}>
                  <FontAwesomeIcon icon={s.icon} />
                </a>
              ))}
            </div>

            <a href={STEM_VERIFY_URL} target="_blank" rel="noopener noreferrer" className="rmf-stem">
              <img src="/assets/img/hero/stem-accredited.png" alt="STEM.org Accredited Educational Experience" />
              <span>
                Verify accreditation
                <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
              </span>
            </a>
          </div>
        </div>
      </div>

      <div className="rmf-bottom">
        <div className="rmf-inner rmf-bottom-inner">
          <span>© {year} RoboMind Coding Education. All rights reserved.</span>
          <div className="rmf-legal">
            <Link to="/terms">Terms &amp; Conditions</Link>
            <Link to="/privacy">Privacy Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;